module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7wpTJB/tc-custom/9783968655536.jpg",
      "alt": "This image is the cover for the book Der Frosch mit der Maske, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Der Frosch mit der Maske, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Der Frosch mit der Maske istder deutsche Titel des Romans \"The Fellowship Of The Frog\" von Edgar Wallace. Der große Unbekannte, der Frosch mit der Maske, treibt sein Unwesen in London und hält Scotland Yard in Atem. Im berüchtigten Gasthaus an der Themse ist Inspektor Wade einer ebenso grausigen wie überraschenden Entdeckung auf der Spur. Und in dem alten ehrwürdigen Schloss Garre Castle geht der grüne Bogenschütze um und hinterlässt einen seiner giftgrünen Pfeile in der Brust eines Schlossbewohners.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Edgar Wallace\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Richard Horatio Edgar Wallace (* 1. April 1875 in Greenwich bei London; † 10. Februar 1932 in Hollywood, Kalifornien) war ein englischer Schriftsteller, Drehbuchautor, Regisseur, Journalist und Dramatiker. Er gehört zu den erfolgreichsten englischsprachigen Kriminalschriftstellern.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24980248","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0